import { render, staticRenderFns } from "./SlicedImageLayer.vue?vue&type=template&id=6c06b070&"
import script from "./SlicedImageLayer.vue?vue&type=script&lang=js&"
export * from "./SlicedImageLayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports